import React, { useState } from 'react'
import { Tooltip, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { Select, Checkbox, message } from "antd"
import { editPriorityStore } from "../../../../services/api/apiReGenerateLabel"

const EditStore = ({ item, tooltipEdit, handleToggleTooltipEdit, listProductType, setModal, reload, getDetailStore, listStore }) => {

    const [isOpen, setIsOpen] = useState(false)
    const [productType, setProductType] = useState([])
    const [newStore, setNewStore] = useState('')
    const [isAllStore, setIsAllStore] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState({})

    const listNameSpace = Array.isArray(listStore) && listStore.map(i => i.namespace).filter(store => store !== item.namespace)

    const _handleToggleModal = () => {
        setIsOpen(!isOpen)
        getDetailStore(item._id, setNewStore, setIsAllStore, setProductType)
    }
    const _handleChangeName = e => {
        let _timeOut = null

        const { value } = e.target
        delete error.newStore
        delete error.namespace

        if (_timeOut) clearTimeout(_timeOut)

        _timeOut = setTimeout(() => {
            setNewStore(value)
        }, 500)
    }

    const handleChange = (values) => {
        delete error.productType
        if (values.some(i => i.includes(','))) {
            setProductType(...values.map(i => i.split(",")))
        } else {
            setProductType([...values])
        }
    }

    const _handleChangeCheck = e => {
        const { checked } = e.target
        delete error.productType
        setIsAllStore(checked)
    }

    const _handleCloseModal = () => {
        delete error.productType
        delete error.newStore
        delete error.namespace
        _handleToggleModal()
    }

    const _handleValidate = () => {
        const Err = {}
        let flag = true
        if (!newStore.trim()) Err.newStore = 'Bắt buộc nhập tên store!'
        if (listNameSpace.includes(newStore.trim())) Err.namespace = 'Store đã tồn tại!'
        if (productType.length < 1 && !isAllStore) Err.productType = "Bắt buộc nhập product type!"

        setError(Err)

        if (Object.keys(Err).length > 0) return flag = false
        return flag
    }

    const _handleEdit = async () => {
        const validate = _handleValidate()
        if (!validate) {
            setLoading(false)
            return
        }
        setLoading(true)
        setError({})

        try {
            const payload = {
                namespace: newStore.trim(),
                apply_for_all: isAllStore,
                id: item._id
            }
            if (productType.length && !isAllStore) payload.product_types = productType

            const { data } = await editPriorityStore(payload)
            const { success, message: mes } = data
            if (!success) {
                setLoading(false)
                setModal()
                return message.error(mes)
            }

            setLoading(false)
            setError({})
            message.success('Sửa store thành công!')
            reload()
            setModal()

        } catch (e) {
            setLoading(false)
            throw new Error(e.message)
        }
    }


    return (
        <span title="Sửa">
            <i className="fa fa-edit text-primary fa-lg ml-2" onClick={_handleToggleModal} id={`TooltipEdit${item._id}`} />
            <Tooltip placement="top" isOpen={tooltipEdit} target={`TooltipEdit${item._id}`} toggle={handleToggleTooltipEdit}>
                Sửa Store
            </Tooltip>
            <Modal isOpen={isOpen} toggle={_handleCloseModal}>
                <ModalHeader toggle={_handleCloseModal}>Sửa store ưu tiên</ModalHeader>
                <ModalBody>
                    <div className="NameStore mb-3 row">
                        <label className="col-sm-3 col-form-label font-weight-bold">Store</label>
                        <div className="col-sm-9">
                            <input
                                className="ant-input"
                                placeholder="Nhập namespace"
                                onChange={_handleChangeName}
                                defaultValue={newStore || ''}
                            />
                            {!!error.newStore && (
                                <div className="text-danger mt-1">{error.newStore}</div>
                            )}
                            {!!error.namespace && (
                                <div className="text-danger mt-1">{error.namespace}</div>
                            )}
                        </div>
                    </div>
                    <div className="ProductType mb-3 row">
                        <label className="col-sm-3 col-form-label font-weight-bold">Product type</label>
                        <div className="col-sm-9">
                            <Select
                                options={listProductType}
                                value={productType}
                                mode="tags"
                                allowClear
                                showArrow
                                disabled={isAllStore}
                                style={{
                                    width: '100%',
                                }}
                                placeholder="-- Chọn product type --"
                                onChange={handleChange}
                            />
                            <Checkbox
                                onChange={_handleChangeCheck}
                                checked={isAllStore}
                                className="mt-3"
                            >All product type
                            </Checkbox>
                            {!!error.productType && (
                                <div className="text-danger mt-1">{error.productType}</div>
                            )}
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-secondary mr-auto" disabled={loading} onClick={_handleToggleModal}>
                        Hủy
                    </button>
                    <button className="btn btn-primary" disabled={loading} onClick={_handleEdit}>
                        Lưu
                    </button>
                </ModalFooter>
            </Modal>
        </span>
    )
}

export default EditStore